/* Reusable progressive enhancement for the HTML/Tailwind feature component.
   Set data-video-src to an approved MP4 URL. No video bytes load before visibility.
   Empty or failed sources keep the honest product-photo sequence visible. */
(() => {
  'use strict';
  function initializeMedia(root = document) { root.querySelectorAll('[data-feature-media]').forEach(panel => {
    if(panel.dataset.initialized) return; panel.dataset.initialized = 'true';
    const video = panel.querySelector('[data-feature-video]');
    const frames = [...panel.querySelectorAll('[data-feature-frame]')];
    const button = panel.querySelector('[data-feature-toggle]');
    const icon = panel.querySelector('[data-feature-toggle-icon]');
    const status = panel.querySelector('[data-feature-status]');
    const format = panel.querySelector('[data-feature-format]');
    const preference = matchMedia('(prefers-reduced-motion: reduce)');
    let paused = preference.matches, visible = false, loaded = false, failed = false, current = 0, timer;
    let observer;
    const controller = new AbortController();
    panel._dispose = () => {clearInterval(timer); observer?.disconnect(); video.pause(); controller.abort(); delete panel.dataset.initialized;};
    function refreshButton() {
      button.setAttribute('aria-label', paused ? 'Play product showcase' : 'Pause product showcase');
      button.setAttribute('aria-pressed', String(paused));
      icon.textContent = paused ? '▷' : 'Ⅱ';
      panel.dataset.motion = paused || !visible || document.hidden ? 'paused' : 'playing';
    }
    function sync() {
      clearInterval(timer);
      refreshButton();
      const play = visible && !paused && !document.hidden;
      if (!play) {video.pause(); return;}
      if (panel.dataset.videoSrc && !failed) {
        if (!loaded) {video.muted = true; video.src = panel.dataset.videoSrc; video.load(); loaded = true;}
        video.play().catch(() => {if (failed || !visible || document.hidden) return; paused = true; sync();});
      } else {
        timer = setInterval(() => {
          current = (current + 1) % frames.length;
          frames.forEach((frame, index) => {frame.dataset.active = String(index === current); frame.setAttribute('aria-hidden', String(index !== current));});
          format.textContent = current === 0 ? 'PRODUCT CLOSE-UP' : 'THE PRESENTATION';
        }, 4500);
      }
    }
    frames.forEach((frame, index) => frame.setAttribute('aria-hidden', String(index !== 0)));
    video.addEventListener('playing', () => {video.hidden = false; panel.querySelector('[data-feature-frames]').hidden = true; format.textContent = 'PRODUCT FILM';});
    video.addEventListener('error', () => {
      failed = true; video.hidden = true; panel.querySelector('[data-feature-frames]').hidden = false;
      format.textContent = current === 0 ? 'PRODUCT CLOSE-UP' : 'THE PRESENTATION';
      sync();
    });
    button.addEventListener('click', () => {paused = !paused; status.textContent = paused ? 'Product showcase paused.' : 'Product showcase playing.'; sync();});
    preference.addEventListener('change', () => {paused = preference.matches; sync();}, {signal:controller.signal});
    document.addEventListener('visibilitychange', sync, {signal:controller.signal});
    if ('IntersectionObserver' in window) {
      observer = new IntersectionObserver(entries => {visible = entries[0].isIntersecting; sync();}, {threshold:0.1}); observer.observe(panel);
    } else {visible = true; sync();}
    refreshButton();
  }); }
  initializeMedia();
  document.addEventListener('shopify:section:load', e => initializeMedia(e.target));
  document.addEventListener('shopify:section:unload', e => e.target.querySelectorAll('[data-feature-media]').forEach(p => p._dispose?.()));
})();
